import { defineStore } from 'pinia'

export interface Column {
  key: string
  label: string
  locked?: boolean
  accessorKey?: string
  header?: string
  graphql?: string
}

export const useProductStore = defineStore('product', {
  state: () => ({
    columnPreferences: {} as Record<string, Column[]>,
    currentProduct: null as Record<string, unknown> | null,
  }),
  actions: {
    setColumns(storageKey: string, columns: Column[], persist = true) {
      this.columnPreferences[storageKey] = columns
      if (persist) {
        localStorage.setItem(storageKey, JSON.stringify(columns))
      }
    },
    removeColumns(storageKey: string) {
      delete this.columnPreferences[storageKey]
      localStorage.removeItem(storageKey)
    },
    loadColumns(storageKey: string): Column[] | null {
      if (this.columnPreferences[storageKey]) {
        return this.columnPreferences[storageKey]
      }
      const saved = localStorage.getItem(storageKey)
      if (saved) {
        try {
          const parsed = JSON.parse(saved)
          this.columnPreferences[storageKey] = parsed
          return parsed
        } catch (e) {
          console.error('Failed to parse columns from localStorage', e)
        }
      }
      return null
    },
    setCurrentProduct(product: Record<string, unknown> | null) {
      this.currentProduct = product
    },
  },
})
